import GridLayout from "components/GridLayout";
import Section from "components/Section";
import Banner from "components/Banner";
import Header from "components/Header";
import Layout from "components/Layout";
import Title from "components/Title";
import Image from "next/image";

import womenVrImage from "public/images/women-vr.png";
import labSchema from "public/images/schema-lab.svg";

export default function LabPage() {
  return (
    <Layout>
      <Header
        className="bg-[url('/images/persons/charles-olivier-demers.png')]"
        title={"Laboratoire d’innovation"}
      />
      <main>
        <Banner
          title="Les technologies émergentes au service de l’apprentissage"
          text={
            "Nous explorons les technologies et les comportements humains pour développer et tester de nouvelles solutions d’apprentissage dans les environnements de travail."
          }
          color={"turquoise"}
        />
        <div className="bg-gray-100">
          <Section className="py-24">
            <GridLayout>
              <div>
                <Title
                  color="turquoise"
                  title={"Réinventer l’apprentissage et la formation"}
                  subtitle="Recherche et développement"
                />
                <p className="mt-12 text-2xl">
                  {
                    "Nous concevons des produits de formations ciblant plusieurs mises en situation organisationnelles pour lesquels nous mettons à profit les technologies de réalité virtuelle/augmentée (AR/VR). Elles grandissent en popularité au sein des entreprises : simulations en réalité virtuelle, simulations animées par intelligence artificielle, assistance interactive offerte par la réalité augmentée."
                  }
                </p>
              </div>
              <div>
                <Image
                  className="rounded-lg"
                  alt="Person doing virtual reality in a classroom"
                  src={womenVrImage}
                  width={595}
                  height={393}
                />
                <p className="text-r-2xl mt-9 font-bold">
                  Les solutions de rechange aux formations traditionnelles sont
                  vastes et prometteuses.
                </p>
              </div>
            </GridLayout>
            <GridLayout className="mt-24 text-neutral-700">
              <h3 className="text-r-5xl font-bold">Après l’Agile, le Fazil</h3>
              <p className="text-r-lg fomt-semibold">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
                ultrices enim id magna cursus placerat. Integer semper velit in
                ultricies posuere.
              </p>
            </GridLayout>
            <Image
              className="mt-24"
              src={labSchema}
              alt={"Schema"}
              width={1266}
              height={156}
            />
          </Section>
        </div>
        <Section>
          <GridLayout>
            <div>
              <Title
                title={"Mot foncé 7-8max 25char"}
                subtitle="Collaboration et partenariats"
              />
            </div>
          </GridLayout>
        </Section>
      </main>
    </Layout>
  );
}
